// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"styles_itemWrapper__1L61G","listItem":"styles_listItem__w5pZA"};